import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

export default function MyNavbar() {
    return (
        <>
            {/* Navbar for desktop and tablets */}
            <Navbar bg="dark" variant="dark" expand="lg" className="d-none d-md-flex">
                <Container>
                    <Navbar.Brand href="/" className="ms-5">
                        <h2>Ideate</h2>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <LinkContainer to="/">
                                <Nav.Link>
                                    Home
                                </Nav.Link>
                            </LinkContainer>
                            <LinkContainer to="/friends">
                                <Nav.Link>
                                    Friends
                                </Nav.Link>
                            </LinkContainer>
                            <LinkContainer to="/create">
                                <Nav.Link>
                                    Create Post
                                </Nav.Link>
                            </LinkContainer>
                            <LinkContainer to="/chats">
                                <Nav.Link>
                                    Chats
                                </Nav.Link>
                            </LinkContainer>
                            <LinkContainer to="/myprofile">
                                <Nav.Link>
                                    Profile
                                </Nav.Link>
                            </LinkContainer>
                        </Nav>
                        <Nav className="ms-auto d-flex align-items-center">
                            <form className="d-flex">
                                <i className="bi bi-search me-3 text-light" style={{ fontSize: '1.5rem', cursor: 'pointer' }}></i>
                            </form>
                            <LinkContainer to="/authentication">
                                <Nav.Link>
                                    <i className="bi bi-box-arrow-in-right text-light" style={{ fontSize: '1.5rem', cursor: 'pointer' }}></i>
                                </Nav.Link>
                            </LinkContainer>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            {/* Navbar for mobile devices */}
            <Navbar
                bg="dark"
                variant="dark"
                fixed="bottom"
                className="d-flex d-md-none justify-content-around py-2"
            >
                <LinkContainer to="/">
                    <Nav.Link className='text-white text-center'>
                        <i className="bi bi-house-door-fill" style={{ fontSize: '1.5rem' }}></i>
                        <small className="d-block">Home</small>
                    </Nav.Link>
                </LinkContainer>
                <LinkContainer to="/friends">
                    <Nav.Link className='text-white text-center'>
                        <i className="bi bi-people-fill" style={{ fontSize: '1.5rem' }}></i>
                        <small className="d-block">Friends</small>
                    </Nav.Link>
                </LinkContainer>
                <LinkContainer to="/create">
                    <Nav.Link className='text-white text-center'>
                        <i className="bi bi-plus-circle-fill" style={{ fontSize: '1.5rem' }}></i>
                        <small className="d-block">Create</small>
                    </Nav.Link>
                </LinkContainer>
                <LinkContainer to="/chats">
                    <Nav.Link className='text-white text-center'>
                        <i className="bi bi-chat-fill" style={{ fontSize: '1.5rem' }}></i>
                        <small className="d-block">Chats</small>
                    </Nav.Link>
                </LinkContainer>
                <LinkContainer to="/myprofile">
                    <Nav.Link className='text-white text-center'>
                        <i className="bi bi-person-fill" style={{ fontSize: '1.5rem' }}></i>
                        <small className="d-block">Profile</small>
                    </Nav.Link>
                </LinkContainer>
            </Navbar>
        </>
    );
}
